module.exports = __webpack_public_path__ + "static/media/notebook-icon-hover.130136dc.svg";